module.exports = __webpack_public_path__ + "img/logo-trans.7631264c.png";